export default __webpack_public_path__ + "static/media/BiologyOptimized.d4fface5.webp";